import { Container } from './_Spinner';

export const Spinner = () => {
  return <Container />;
};
